import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@material-ui/core';
import { findIndex } from 'lodash';
import { dialogModes, therapeuticAreaInitialState } from '../Constants';
import { addArea, updateArea } from './therapeuticAreaServices';

function TherapeuticAreaDialog({
  isDialogOpen,
  toggleDialog,
  dialogMode,
  thrapeuticAreaToEdit,
  changeDialogMode,
  setThrapeuticAreaToEdit,
  addNewArea,
  editArea,
  categoryId,
}) {
  useEffect(() => {
    if (thrapeuticAreaToEdit) setNewTherapeuticArea(thrapeuticAreaToEdit);
  }, [thrapeuticAreaToEdit]);

  const [newTherapeuticArea, setNewTherapeuticArea] = useState(
    thrapeuticAreaToEdit
      ? thrapeuticAreaToEdit
      : therapeuticAreaInitialState(categoryId)
  );

  const updateThrapeuticArea = (propName, propValue) => {
    const therapeuticArea = { ...newTherapeuticArea };
    therapeuticArea[propName] = propValue;
    setNewTherapeuticArea(therapeuticArea);
  };

  const addNewTherapeuticArea = () => {
    addNewArea(newTherapeuticArea, () => {
      setNewTherapeuticArea(therapeuticAreaInitialState(categoryId));
      toggleDialog(false);
    });
  };

  const editTherapeuticArea = () => {
    editArea(newTherapeuticArea, () => {
      setNewTherapeuticArea(therapeuticAreaInitialState(categoryId));
      changeDialogMode(dialogModes.add);
      setThrapeuticAreaToEdit(null);
      toggleDialog(false);
    });
  };

  const upsertTherapeuticArea = () =>
    dialogMode === dialogModes.add
      ? addNewTherapeuticArea()
      : editTherapeuticArea();

  const cancelUpsert = () => {
    setNewTherapeuticArea(therapeuticAreaInitialState(categoryId));
    changeDialogMode(dialogModes.add);
    setThrapeuticAreaToEdit(null);
    toggleDialog(false);
  };

  return (
    <Dialog open={isDialogOpen}>
      <DialogTitle>{`${
        dialogMode === dialogModes.add ? 'Add new' : 'Update'
      } Therapeutic category`}</DialogTitle>
      <DialogContent>
        <Grid container style={{ flexGrow: 1 }} justify="center">
          <TextField
            id="name"
            label="Therapeutic area name"
            variant="outlined"
            fullWidth
            style={{ marginBottom: '16px' }}
            value={newTherapeuticArea.name}
            onChange={e => updateThrapeuticArea('name', e.target.value)}
            autoFocus
            required
            error={!newTherapeuticArea.name}
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={!newTherapeuticArea.name}
          variant="outlined"
          color="primary"
          onClick={upsertTherapeuticArea}
        >
          {dialogMode === dialogModes.add ? 'Add' : 'Update'}
        </Button>
        <Button variant="outlined" onClick={cancelUpsert} color="secondary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const mapDispatchToProps = dispatch => ({
  addNewArea: (area, cb) => dispatch(addArea(area, cb)),
  editArea: (area, cb) => dispatch(updateArea(area, cb)),
});

export default connect(null, mapDispatchToProps)(TherapeuticAreaDialog);



// WEBPACK FOOTER //
// ./src/therapeuticArea/TherapeuticAreaDialog.js